/**
 * Send the file to S3, not to the API.
 *
 * The bare `axios` import, not the `apiClient` instance from `./index.ts` —
 * `apiClient` carries `withCredentials: true` and a `baseURL` pointed at this
 * app's own API, while `url` here is a presigned S3 URL that must receive no
 * cookies and no extra headers beyond `Content-Type`. A mismatched
 * `Content-Type` is a signature failure, which is the correct outcome for a
 * client claiming one type and sending another.
 */

import axios from 'axios';

export function putToStorage(
	url: string,
	file: File,
	onProgress?: (percent: number) => void,
): Promise<void> {
	return axios
		.put(url, file, {
			headers: {
				'Content-Type': file.type || 'application/octet-stream',
			},
			onUploadProgress: (event) => {
				if (event.total)
					onProgress?.(
						Math.round((event.loaded / event.total) * 100),
					);
			},
		})
		.then(() => undefined);
}
